import React from 'react';
import theme from './MainRouting.module.scss';
import { Redirect, Route, Switch } from 'react-router-dom';
import LoginPage from 'components/LoginPage';
import { Home } from '../Home';
import UsersTable from '../Users/UsersTable';
import { useAsyncState } from 'utils/hooks';
import { getCurrentUser } from 'services/auth';
import Sidebar from 'components/Sidebar/Sidebar';
import LogoutPage from 'components/LogoutPage';
import ProjectsTable from 'components/Projects/ProjectsTable';
import ProjectDetails from 'components/Projects/ProjectDetails';
import ProfileTable from 'components/Profiles/ProfilesTable';
import ProfileDetails from 'components/Profiles/Profile/ProfileDetails';
import BygrStatisticsDashboard from 'components/Statistics/BygrStatisticsDashboard';
import ResidentialUnit from 'components/Projects/ResidentialUnit';
import { About } from 'components/About/About';
import { LicenseOverview } from 'components/Licenses/LicenseOverview';
import { UserDetails } from 'components/Users/UserDetails';
import InvitationsPage from 'components/Invitations/InvitationsPage';
import { FeaturesOverview } from 'components/Features/FeaturesOverview';
import { FeatureInfo } from 'components/Features/FeatureInfo';
import ElectricitySupplierTable from 'components/ServiceProviders/ElectricitySupplierTable';
import ElectricitySupplierDetails from 'components/ServiceProviders/ElectricitySupplierDetails';

interface MainRoutingProps {}

const MainRouting: React.FC<MainRoutingProps> = (props) => {
    const [user] = useAsyncState(() => getCurrentUser(), [], null);

    if (!user) {
        return null;
    }

    if (!user.isLoggedIn) {
        return (
            <div className={theme.content}>
                <LoginPage />
            </div>
        );
    }

    return (
        <div className={theme.content}>
            <Sidebar />
            <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/about" component={About} />
                <Route exact path="/statistics" component={BygrStatisticsDashboard} />

                {/* <Route exact path="/login" component={Home} /> */}
                <Route exact path="/logout" component={LogoutPage} />
                <Route exact path="/users" component={UsersTable} />
                <Route exact path="/licenses" component={LicenseOverview} />

                <Route exact path="/users/:userId/:tab" component={UserDetails} />
                <Redirect exact path="/users/:userId" to="/users/:userId/dashboard" />

                <Route exact path="/projects" component={ProjectsTable} />
                <Route exact path="/projects/:projectId/units/:residentialUnitId" component={ResidentialUnit} />
                <Route exact path="/projects/:projectId/:tab" component={ProjectDetails} />
                <Redirect exact path="/projects/:projectId" to="/projects/:projectId/dashboard" />

                <Route exact path="/profiles" component={ProfileTable} />
                <Route exact path="/profiles/:profileId/:tab" component={ProfileDetails} />
                <Redirect exact path="/profiles/:profileId" to="/profiles/:profileId/dashboard" />

                <Route exact path="/invitations/:tab" component={InvitationsPage} />
                <Redirect exact path="/invitations" to="/invitations/profile" />

                <Route exact path={'/features'} component={FeaturesOverview} />
                <Route exact path={'/features/:feature'} component={FeatureInfo} />

                <Route exact path="/electricity-suppliers" component={ElectricitySupplierTable} />
                <Route exact path="/electricity-suppliers/:offerId" component={ElectricitySupplierDetails} /> 

            </Switch>
        </div>
    );
};

export default MainRouting;
